import baseEditForm from "formiojs/components/_classes/component/Component.form";

export default (...extend) => {
  return baseEditForm(
    [
      {
        key: "display",
        components: []
      },
      {
        key: "data",
        components: [
          {
            weight: -10,
            label: "Select Multiple Damage Areas",
            key: "multipleAreas",
            type: "checkbox",
            input: true
          },
          {
            weight: -10,
            label: "Vehicle Type Component Name",
            key: "compToMatch",
            type: "textfield",
            input: true
          },
          {
            weight: -10,
            label: "Diagram Mappings",
            key: "diagramMappings",
            type: "editgrid",
            input: true,
            addAnother: "Add Diagram Mapping",
            storeas: "array",
            templates: {
              header: '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Diagram Mapping(s)</strong>\n  </div>\n</div>',
              row: '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n{{ row.name }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                label: "Name",
                key: "name",
                input: true,
                type: "textfield"
              },
              {
                label: "Image",
                key: "image",
                input: true,
                type: "select",
                dataSrc: "values",
                data: {
                  values: [
                    {
                      key: "diagramCar",
                      label: "Car",
                      value: "diagramCar"
                    },
                    {
                      key: "diagramCarTrailer",
                      label: "Car Trailer",
                      value: "diagramCarTrailer"
                    },
                    {
                      key: "diagramVan",
                      label: "Van",
                      value: "diagramVan"
                    },
                    {
                      key: "diagramTruck",
                      label: "Truck",
                      value: "diagramTruck"
                    },
                    {
                      key: "diagramMotorCycle",
                      label: "Motorcycle",
                      value: "diagramMotorCycle"
                    },
                    {
                      key: "diagramFarmVehicle",
                      label: "Farm Vehicle",
                      value: "diagramFarmVehicle"
                    },
                    {
                      key: "diagramPickUp",
                      label: "Pickup",
                      value: "diagramPickUp"
                    },
                    {
                      key: "diagramSchoolBus",
                      label: "School Bus",
                      value: "diagramSchoolBus"
                    },
                    {
                      key: "diagramTractorCabOnly",
                      label: "Tractor Cab Only",
                      value: "diagramTractorCabOnly"
                    },
                    {
                      key: "diagramTractorSingleTrailer",
                      label: "Tractor Single Trailer",
                      value: "diagramTractorSingleTrailer"
                    },
                    {
                      key: "diagramTruck3OrMoreAxils",
                      label: "Truck 3 or More Axles",
                      value: "diagramTruck3OrMoreAxils"
                    },
                    {
                      key: "diagramTruckTrailer",
                      label: "Truck Trailer",
                      value: "diagramTruckTrailer"
                    },
                    {
                      key: "diagramBus",
                      label: "Bus",
                      value: "diagramBus"
                    }
                  ]
                }
              },
              {
                type: "editgrid",
                label: "Vehicle Type Values",
                key: "values",
                input: true,
                addAnother: "Add Value",
                templates: {
                  header: '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Value(s)</strong>\n  </div>\n</div>',
                  row: '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n{{ row.value }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info btn-sm editRow">Edit</div> \n      <div class="btn btn-danger btn-sm removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
                  footer: ""
                },
                components: [
                  {
                    label: "Vehicle Type Value",
                    key: "value",
                    input: true,
                    type: "textfield"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: "validation",
        components: []
      },
      {
        key: "api",
        components: []
      },
      {
        key: "conditional",
        components: []
      },
      {
        key: "logic",
        components: []
      },
      {
        key: "impactSettingsTab",
        label: "Impact Settings",
        components: [
          {
            weight: -10,
            label: "Damage Area 1 Value",
            key: "area1",
            type: "textfield",
            input: true,
            defaultValue: "01",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 2 Value",
            key: "area2",
            type: "textfield",
            input: true,
            defaultValue: "02",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 3 Value",
            key: "area3",
            type: "textfield",
            input: true,
            defaultValue: "03",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 4 Value",
            key: "area4",
            type: "textfield",
            input: true,
            defaultValue: "04",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 5 Value",
            key: "area5",
            type: "textfield",
            input: true,
            defaultValue: "05",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 6 Value",
            key: "area6",
            type: "textfield",
            input: true,
            defaultValue: "06",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 7 Value",
            key: "area7",
            type: "textfield",
            input: true,
            defaultValue: "07",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 8 Value",
            key: "area8",
            type: "textfield",
            input: true,
            defaultValue: "08",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 9 Value",
            key: "area9",
            type: "textfield",
            input: true,
            defaultValue: "09",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 10 Value",
            key: "area10",
            type: "textfield",
            input: true,
            defaultValue: "10",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 11 Value",
            key: "area11",
            type: "textfield",
            input: true,
            defaultValue: "11",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Damage Area 12 Value",
            key: "area12",
            type: "textfield",
            input: true,
            defaultValue: "12",
            validate: { required: true }
          },
          {
            weight: -10,
            label: "Additional Impact Areas",
            key: "additionalImpactAreas",
            type: "editgrid",
            input: true,
            addAnother: "Add Impact Area",
            storeas: "array",
            templates: {
              header: '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Additional Impact Areas(s)</strong>\n  </div>\n</div>',
              row: '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n Area: {{ row.impactAreaContainer.value }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                weight: -10,
                input: true,
                key: "impactAreaContainer",
                type: "container",
                label: "New Impact Area:",
                components: [
                  {
                    label: "Value",
                    weight: -10,
                    key: "id",
                    input: true,
                    type: "textfield"
                  },
                  {
                    weight: -10,
                    type: "textfield",
                    key: "value",
                    label: "Label",
                    input: true
                  }
                ]
              }
            ]
          },
          {
            weight: -10,
            label: "Disable Impact Areas",
            key: "disableImpactAreas",
            type: "editgrid",
            input: true,
            addAnother: "Disable Impact Area",
            storeas: "array",
            templates: {
              header: '<div class="row"> \n  <div class="col-sm-12">\n    <strong>{{ value.length }} Disabled Impact Area(s)</strong>\n  </div>\n</div>',
              row: '<div class="row"> \n  <div class="col-sm-6">\n   <b>\n Area: {{ row.disableAreaContainer.id }}</b>\n  </div>\n  <div class="col-sm-6"> \n    <div class="btn-group pull-right"> \n      <div class="btn btn-info editRow">Edit</div> \n      <div class="btn btn-danger removeRow">Delete</div> \n    </div> \n  </div> \n</div>',
              footer: ""
            },
            components: [
              {
                weight: -10,
                input: true,
                key: "disableAreaContainer",
                type: "container",
                label: "Disabled Area:",
                unique: true,
                components: [
                  {
                    label: "Value",
                    weight: -10,
                    key: "id",
                    input: true,
                    type: "textfield",
                    placeholder: "Enter the value for which Impact Area you wish to disable."
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    ...extend
  );
};
